import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

//TODO: I will change this param with  new ApiCommonParams type here after we merge
export function indexStudentSessions(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});

  return Axios.get("v1/students/sessions/", { params });
}

export function showStudentSessions(
  sessionId: number | string,
  referrer?: string
): Promise<ApiResponse> {
  const params: { referrer?: string } = {};
  if (!!referrer) {
    params["referrer"] = referrer;
  }
  return Axios.get(`v1/students/sessions/${sessionId}`, { params });
}
export function showInProgressSessions(): Promise<ApiResponse> {
  return Axios.get(`/v1/students/sessions/in_progress`);
}
export function studentCancelSession(slot: object): Promise<ApiResponse> {
  return Axios.post("/v1/students/cancellations", slot);
}
